"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Breadcrumb_component_exports = {};
__export(Breadcrumb_component_exports, {
  Breadcrumb: () => Breadcrumb,
  default: () => Breadcrumb_component_default
});
module.exports = __toCommonJS(Breadcrumb_component_exports);
var import_react = __toESM(require("react"));
var import_react2 = require("react");
var import_debounce = __toESM(require("lodash/debounce"));
var import_react_i18next = require("react-i18next");
var import_useEventListener = require("../../../utils/useEventListener/useEventListener.hook");
var import_Breadcrumb = require("./Breadcrumb.styled");
var import_BreadcrumbEllipsis = require("./BreadcrumbEllipsis.component");
var import_BreadcrumbItem = require("./BreadcrumbItem.component");
var import_i18n = __toESM(require("../../../i18n"));
var _excluded = ["variant", "darkMode", "hasCurrentItem", "ellipsisPlacementForCompactVariant", "ellipsisPopoverPlacement", "disableEllipsis", "readOnly"];
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0, F = function F2() {
      };
      return { s: F, n: function n() {
        return _n >= r.length ? { done: true } : { done: false, value: r[_n++] };
      }, e: function e2(r2) {
        throw r2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a = true, u = false;
  return { s: function s() {
    t = t.call(r);
  }, n: function n() {
    var r2 = t.next();
    return a = r2.done, r2;
  }, e: function e2(r2) {
    u = true, o = r2;
  }, f: function f() {
    try {
      a || null == t["return"] || t["return"]();
    } finally {
      if (u)
        throw o;
    }
  } };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var Breadcrumb = function Breadcrumb2(_ref) {
  var _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "big" : _ref$variant, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, _ref$hasCurrentItem = _ref.hasCurrentItem, hasCurrentItem = _ref$hasCurrentItem === void 0 ? false : _ref$hasCurrentItem, _ref$ellipsisPlacemen = _ref.ellipsisPlacementForCompactVariant, ellipsisPlacementForCompactVariant = _ref$ellipsisPlacemen === void 0 ? "beginning" : _ref$ellipsisPlacemen, _ref$ellipsisPopoverP = _ref.ellipsisPopoverPlacement, ellipsisPopoverPlacement = _ref$ellipsisPopoverP === void 0 ? "bottom" : _ref$ellipsisPopoverP, _ref$disableEllipsis = _ref.disableEllipsis, disableEllipsis = _ref$disableEllipsis === void 0 ? false : _ref$disableEllipsis, _ref$readOnly = _ref.readOnly, readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly, props = _objectWithoutProperties(_ref, _excluded);
  var ellipsisWidth = 32;
  var breadcrumbRef = (0, import_react2.useRef)(null);
  var listRef = (0, import_react2.useRef)(null);
  var _useState = (0, import_react2.useState)([]), _useState2 = _slicedToArray(_useState, 2), breadcrumbItemWidths = _useState2[0], setBreadcrumbItemWidths = _useState2[1];
  var _useState3 = (0, import_react2.useState)("default"), _useState4 = _slicedToArray(_useState3, 2), ellipsisVariant = _useState4[0], setEllipsisVariant = _useState4[1];
  var _useState5 = (0, import_react2.useState)(0), _useState6 = _slicedToArray(_useState5, 2), widthDeficiency = _useState6[0], setWidthDeficiency = _useState6[1];
  var _useState7 = (0, import_react2.useState)(false), _useState8 = _slicedToArray(_useState7, 2), showEllipsis = _useState8[0], setShowEllipsis = _useState8[1];
  var _useState9 = (0, import_react2.useState)(0), _useState10 = _slicedToArray(_useState9, 2), childWidth = _useState10[0], setChildWidth = _useState10[1];
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  var getBreadcrumbItemWidths = function getBreadcrumbItemWidths2() {
    var listElement = listRef.current;
    var listItems = listElement.querySelectorAll("li");
    var listItemWidths = [];
    var _iterator = _createForOfIteratorHelper(listItems), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var listItem = _step.value;
        listItemWidths.push(listItem.clientWidth);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return listItemWidths;
  };
  var updateEllipsisStatus = function updateEllipsisStatus2(listWidth, listItemWidths) {
    var breadcrumbElement = breadcrumbRef.current;
    if (breadcrumbElement) {
      if (breadcrumbElement.clientWidth < listWidth) {
        setWidthDeficiency(listWidth - breadcrumbElement.clientWidth);
        var minWidthForDefaultVariant = listItemWidths[0] + listItemWidths[listItemWidths.length - 1] + ellipsisWidth;
        if (breadcrumbElement.clientWidth < minWidthForDefaultVariant) {
          setEllipsisVariant("compact");
        } else {
          setEllipsisVariant("default");
        }
        setShowEllipsis(true);
      } else {
        setShowEllipsis(false);
      }
    }
  };
  (0, import_react2.useEffect)(function() {
    var timer = setTimeout(function() {
      var _listRef$current;
      var listItemWidths = getBreadcrumbItemWidths();
      var listWidth = childWidth || ((_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.clientWidth);
      setBreadcrumbItemWidths(listItemWidths);
      setChildWidth(listWidth);
      updateEllipsisStatus(listWidth, listItemWidths);
    }, 100);
    return function() {
      clearTimeout(timer);
    };
  }, []);
  (0, import_useEventListener.useEventListener)("resize", (0, import_debounce.default)(function() {
    return updateEllipsisStatus(childWidth, breadcrumbItemWidths);
  }, 200));
  var getEllipsisLastItemIndex = function getEllipsisLastItemIndex2() {
    var spaceDeficiency = widthDeficiency;
    var itemIndex = 0;
    while (spaceDeficiency > 0) {
      itemIndex += 1;
      spaceDeficiency -= breadcrumbItemWidths[itemIndex];
      if (itemIndex === 1) {
        spaceDeficiency += ellipsisWidth;
      }
    }
    return itemIndex;
  };
  var getEllipsisBreadcrumbItems = function getEllipsisBreadcrumbItems2() {
    var childrenArray = import_react2.Children.toArray(props.children);
    if (ellipsisVariant === "default") {
      var ellipsisLastItemIndex = getEllipsisLastItemIndex();
      return childrenArray.filter(function(c, i) {
        return i > 0 && i <= ellipsisLastItemIndex;
      });
    }
    if (ellipsisPlacementForCompactVariant === "beginning") {
      return childrenArray.slice(0, childrenArray.length - 1);
    }
    return childrenArray.slice(1);
  };
  var getBreadcrumbItemsAfterEllipsis = function getBreadcrumbItemsAfterEllipsis2() {
    var childrenCount = import_react2.Children.count(props.children);
    if (ellipsisVariant === "default") {
      var ellipsisLastItemIndex = getEllipsisLastItemIndex();
      return import_react2.Children.map(props.children, function(child, i) {
        if (i > ellipsisLastItemIndex) {
          if (!/* @__PURE__ */ (0, import_react2.isValidElement)(child) || child.type !== import_BreadcrumbItem.BreadcrumbItem) {
            throw new Error("Only BreadcrumbItem component can be rendered as a child of Breadcrumb.");
          }
          return /* @__PURE__ */ (0, import_react2.cloneElement)(child, {
            variant,
            darkMode,
            showSeparator: i < childrenCount - 1,
            isCurrentItem: hasCurrentItem && i === childrenCount - 1,
            currentItemColor: props.currentItemColor,
            readOnly
          });
        }
        return void 0;
      });
    }
    if (ellipsisPlacementForCompactVariant === "beginning") {
      return /* @__PURE__ */ (0, import_react2.cloneElement)(props.children[childrenCount - 1], {
        variant,
        darkMode,
        showSeparator: false,
        isCurrentItem: hasCurrentItem,
        currentItemColor: props.currentItemColor,
        readOnly
      });
    }
    return void 0;
  };
  var getBreadcrumbList = function getBreadcrumbList2() {
    if (showEllipsis && !disableEllipsis) {
      return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, (ellipsisVariant === "default" || ellipsisPlacementForCompactVariant === "end") && /* @__PURE__ */ (0, import_react2.cloneElement)(props.children[0], {
        variant,
        darkMode,
        isCurrentItem: false,
        currentItemColor: props.currentItemColor,
        readOnly
      }), /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledBreadcrumbItem, null, /* @__PURE__ */ import_react.default.createElement(import_BreadcrumbEllipsis.BreadcrumbEllipsis, {
        variant,
        darkMode,
        ariaLabel: props.ellipsisAriaLabel || t("base_constant_moreItems"),
        popoverPlacement: ellipsisPopoverPlacement,
        items: getEllipsisBreadcrumbItems(),
        color: props.ellipsisColor,
        popoverHasCurrentItem: hasCurrentItem && ellipsisVariant === "compact" && ellipsisPlacementForCompactVariant === "end",
        readOnly
      }), (ellipsisVariant === "default" || ellipsisPlacementForCompactVariant !== "end") && /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledSeparator, {
        darkMode,
        variant,
        "aria-hidden": "true"
      }, "|")), getBreadcrumbItemsAfterEllipsis());
    }
    var childrenCount = import_react2.Children.count(props.children);
    return import_react2.Children.map(props.children, function(child, i) {
      if (!/* @__PURE__ */ (0, import_react2.isValidElement)(child) || child.type !== import_BreadcrumbItem.BreadcrumbItem) {
        throw new Error("Only BreadcrumbItem component can be rendered as a child of Breadcrumb.");
      }
      return /* @__PURE__ */ (0, import_react2.cloneElement)(child, {
        variant,
        darkMode,
        showSeparator: i < childrenCount - 1,
        isCurrentItem: hasCurrentItem && i === childrenCount - 1,
        currentItemColor: props.currentItemColor,
        readOnly
      });
    });
  };
  return /* @__PURE__ */ import_react.default.createElement(import_react_i18next.I18nextProvider, {
    i18n: import_i18n.default
  }, /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledBreadcrumb, {
    ref: breadcrumbRef,
    "aria-label": props.ariaLabel ? props.ariaLabel : t("dp_core_breadcrumb_label_other"),
    className: props.className
  }, /* @__PURE__ */ import_react.default.createElement(import_Breadcrumb.StyledBreadcrumbList, {
    ref: listRef
  }, getBreadcrumbList())));
};
Breadcrumb.BreadcrumbItem = import_BreadcrumbItem.BreadcrumbItem;
var Breadcrumb_component_default = Breadcrumb;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Breadcrumb
});
//# sourceMappingURL=Breadcrumb.component.js.map